import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Select from 'material-ui/Select'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Checkbox from 'material-ui/Checkbox'
import TextField from 'material-ui/TextField'
import Tabs, { Tab } from 'material-ui/Tabs'
import Switch from 'material-ui/Switch'
import Grid from 'material-ui/Grid';
import Radio, { RadioGroup } from 'material-ui/Radio';
import { toast } from 'react-toastify'
import Chip from "material-ui/Chip";
import Divider from "material-ui/Divider";
import Qualification from "../qualification";
import FiberQualification from "../fiberqualification";

import {
  getQualification
} from "../../../../redux/actions";

import {
  FormControl,
  FormHelperText,
  FormControlLabel,
  FormLabel,
  FormGroup
} from 'material-ui/Form'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { connect } from "react-redux";

import {
  DraggableModalFrame,
  ModalHeader,
  ModalContents,
  ModalFooter
} from '../../../common/modal'

import {
  validateFormData
} from '../../../../common/formtool'

import {
  CUSTOM_METADATA_STANDARD
} from '../../../../common/constants'


class QualificationEditTests extends React.Component {

  constructor(props) {
    super(props)
    const { job, test, type } = props
    this.state = {
      editSaving: false,
      open: true,
      errors: {},
      tabs: [],
      tabPosition: 0,
      test: {
        "jobid": job.id,
        "name": '',
        "floor": '',
        "telecommunicationspace": '',
        "panel": '',
        "metadata": [{
          "level": "1",
          "value": "",
          "field": job.level1,
          default: false,
          enabled: false
        },
        {
          "level": "2",
          "value": "",
          "field": job.level2,
          default: false,
          enabled: false
        },
        {
          "level": "3",
          "value": "",
          "field": job.level3,
          default: false,
          enabled: false
        },
        {
          "level": "4",
          "value": "",
          "field": job.level4,
          default: false,
          enabled: false
        },
        {
          "level": "5",
          "value": "",
          "field": job.level5,
          default: false,
          enabled: false
        },
        {
          "level": "6",
          "value": "",
          "field": job.level6,
          default: false,
          enabled: false
        }],
        allowMetadataEdit: false,
        allmetadataoptions: false
      },
      disabledToogleIdentifier: false,
      hasResult: false,
      testHasResultWithMetaData: false,
      testCount: 0,
      isSubTestError: false,
      tabView: "tab_details",
      selectedTestResult: null,
      editModalOpen: false,
      qualification: null,
      fiberQualification: null,
      isTestInit: false,
      subtestSettings: null,
      findreplacetestnames: false,
      addchangeengineer: false,
      findName: '',
      replaceName: '',
      engineerName: '',
      modalRef: React.createRef()
    }
  }

  componentWillUnmount() {
    const { sessionStorage } = window;
    this.props.resetForm()
    sessionStorage.removeItem("QTDEFAULT");
  }
  componentWillMount() {
    const { test } = this.state;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
  }

  componentDidMount() {
    const { test } = this.state;
    const disabledToogleIdentifier = test.metadata
      .filter(identifier => identifier.level !== "1")
      .every(identifier => identifier.default === true);
    this.setState({
      disabledToogleIdentifier
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      qualification,
      fiberQualification
    } = prevProps;
    if (qualification && this.props.qualification != qualification) {
      this.setState({ qualification });
    }
    if (fiberQualification && this.props.fiberQualification != fiberQualification) {
      this.setState({ fiberQualification });
    }
  }

  handleTabChange = (event, value) => {
    let { tabPosition, tabs } = this.state;
    let prevTabClicked = tabPosition > value;
    let allowTabChange = prevTabClicked ? true : this.validate();
    if (allowTabChange) {
      this.setState({ tabPosition: value, tabView: tabs[value] });
    }
  };

  tabNext() {
    const { tabs, tabPosition } = this.state;
    const { userPreference } = this.props;
    let pos = tabPosition + 1;
    let check = this.canTabNext();
    if (this.props.job.metadatalookupid === CUSTOM_METADATA_STANDARD || (userPreference && userPreference.FromTreeview)) {
      if (tabPosition > 1) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    } else {
      if (tabPosition > 0) {
        if (check.can)
          this.setState({
            tabPosition: check.pos,
            tabView: tabs[check.pos]
          });
      } else {
        let validate = this.validate();
        if (validate && check.can)
          this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
      }
    }
    this.state.modalRef.current.scrollTo({top: 0});
  }

  tabBack() {
    const { tabs, tabPosition } = this.state;
    let check = this.canTabBack();
    if (check.can)
      this.setState({ tabPosition: check.pos, tabView: tabs[check.pos] });
    this.state.modalRef.current.scrollTo({top: 0});
  }

  canTabNext() {
    const { tabs, tabPosition } = this.state;
    let pos = tabPosition + 1;

    return pos < tabs.filter(n => n).length
      ? { can: true, pos: pos }
      : { can: false, pos: pos };
  }

  canTabBack() {
    const { tabPosition } = this.state;
    let pos = tabPosition - 1;
    return pos >= 0 ? { can: true, pos: pos } : { can: false, pos: pos };
  }

  tabsComplete() {
    const { tabs, tabPosition } = this.state;
    return tabPosition === tabs.filter(n => n).length - 1 ? true : false;
  }

  handleClose = () => {
    this.setState({
      open: false
    })
    this.props.cancel()
  }

  compare = (a, b) => {
    if (a.name < b.name) {
      return -1;
    } else if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  onChange = (e) => {
    const self = this
    let test = { ...this.state.test }
    let cablemodels = self.state.cablemodels || []
    let linkmodels = self.state.linkmodels || []
    let cabletypes = self.state.cabletypes || []
    let isNonGenericCableBrand = self.state.isNonGenericCableBrand
    let errors = { ...this.state.errors }
    errors = {
      ...errors,
      [e.target.name]: false
    }
    test[e.target.name] = e.target.value
    this.setState({ test, errors, cablemodels, isNonGenericCableBrand })
  }

  onToggleChange = (e, checked) => {
    let test = { ...this.state.test };
    test[e.target.name] = checked;
    this.setState({ test: test });
  };

  onCustomCheckChange = (e) => {
    let test = { ...this.state.test };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let enabled = !metadataOption.enabled;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      enabled: enabled,
      default: enabled,
      field: document.querySelector(`select[name="${e.target.name}"]`).value
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  }

  onCustomChange = (e) => {
    let test = { ...this.state.test };

    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let field = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      field
    };
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test: test });
  }

  onChangeMetadataField = (e) => {
    let { test, errors } = { ...this.state };
    let metadataOption = test.metadata.find(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    let value = e.target.value;
    let idx = test.metadata.findIndex(
      x => parseInt(x.level, 10) === parseInt(e.target.name, 10)
    );
    metadataOption = {
      value
    };
    errors[e.target.name] = false;
    test.metadata[idx] = { ...test.metadata[idx], ...metadataOption };
    this.setState({ test, errors });
  }


  validate = currentTab => {
    const { test, tabPosition, testCount, findreplacetestnames, addchangeengineer, engineerName, findName } = this.state;
    const { job, translate, multiple } = this.props;
    let validationData = {};
    let errors = {};
    if (tabPosition < 3) {
      switch (currentTab || currentTab === 0 ? currentTab : tabPosition) {
        case 0:
          validationData = {
            name: {
              required: translate("formfield_error_general_required"),
              type: { value: 'alphanumericspecial', message: translate("formfield_error_general_type_alphanumeric") }
            }
          }
          break;
        case 1:
          test.metadata.map(x => {
            if (x.enabled && x.field != null && x.value.trim() === "") {
              errors[x.level] = true;
            } else if (x.enabled && x.field != null && x.value.length > 12) {
              errors[x.level] = true;
            }
          });
          break;
        case 2:
          if (findreplacetestnames) {
            validationData = {
              findName: {
                required: translate("formfield_error_general_required")
              }
            }
          }
          if (addchangeengineer) {
            validationData["engineerName"] = {
              required: translate("formfield_error_general_required")
            }
          }
          break;
        default:
          return true;
      }

      if (
        tabPosition === 1 &&
        job.metadatalookupid === CUSTOM_METADATA_STANDARD
      ) {
      } else {
        errors = validateFormData({ ...test, engineerName, findName }, validationData);
      }
      if (multiple && tabPosition === 0) {
        test.metadata.map(x => {
          if (x.enabled && x.field != null && x.value.trim() === "") {
            errors[x.level] = true;
          } else if (x.enabled && x.field != null && x.value.length > 12) {
            errors[x.level] = true;
          }
        });
      } else if (multiple) {
        currentTab = tabPosition
        if (findreplacetestnames) {
          validationData = {
            findName: {
              required: translate("formfield_error_general_required")
            }
          }
        }
        if (addchangeengineer) {
          validationData["engineerName"] = {
            required: translate("formfield_error_general_required")
          }
        }
        errors = validateFormData({ ...test, engineerName, findName }, validationData);
      }

      const missingFieldName = Object.keys(errors)[0];
      if (missingFieldName) {
        const textField = document.getElementsByName(missingFieldName)[0];
        textField && textField.focus();

        if (Number.isInteger(parseInt(missingFieldName))) {
          toast.error(
            ` ${this.props.translate("test_create_invalid_identifier")}`,
            {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true
            }
          );
        }
      }
    }
    if (Object.keys(errors).length) {
      if (!currentTab && currentTab !== 0) {
        this.setState({ errors });
      } else {
        this.setState({ errors, tabPosition: currentTab });
      }
      return false;
    } else {
      this.setState({ errors });
      return true;
    }
  };

  editTest() {
    let isValidated = false
    let subtestValidation = false
    let errors = {}
    let { test, allowMetadataEdit } = this.state

    const { multiple, isCopper, isFiber, hasResult, onlyCopper, onlyFiber, allCoperHasResult, allFiberHasResult, partialResult, mixedIdentifiers } = this.props
    const { tabPosition, testCount, findreplacetestnames, addchangeengineer, findName, replaceName, engineerName } = this.state
    for (let currentTab = 0; currentTab <= tabPosition; currentTab++) {
      isValidated = this.validate(currentTab)
      if (!isValidated) {
        return
      }
    }
    if (allowMetadataEdit && !mixedIdentifiers) {
      test.metadata.map(x => {
        if (x.enabled && x.field != null && x.value.trim() === "") {
          errors[x.level] = true;
        } else if (x.enabled && x.field != null && x.value.length > 12) {
          errors[x.level] = true;
        }
      });
    }
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
      if (Number.isInteger(parseInt(missingFieldName))) {
        toast.error(
          ` ${this.props.translate("test_create_invalid_identifier")}`,
          {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true
          }
        );
      }
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
    } else {
      if (isValidated) {
        const { job, pager } = this.props

        if (!this.validate()) {
          return
        }
        if(allowMetadataEdit) {
          let metadata = [...test.metadata];
          metadata.map(e => {
            if (!e.enabled) {
              e.field = "";
              e.value = "";
              return e;
            }
          });
          test.metadata = metadata;
        }
        test.allowMetadataEdit = allowMetadataEdit

        this.props.type == "fiber"
          ? (test.interfaceid = 1)
          : (test.interfaceid = 0);

        if (!multiple) {
          if (isCopper || isFiber) {
            if (hasResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          }
        } else if (multiple) {
          if (onlyCopper) {
            if (allCoperHasResult || partialResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          } else if (onlyFiber) {
            if (allFiberHasResult || partialResult) {
              subtestValidation = false
            } else {
              subtestValidation = true
            }
          } else {
            subtestValidation = false
          }
        }

        let signaltekeditdetails = {
          replace: findreplacetestnames,
          findName: findName,
          replacename: replaceName,
          addChangeengineer: addchangeengineer,
          engineerName: engineerName
        }

        if (testCount <= 0 && subtestValidation) {
          this.setState({ isSubTestError: true });
        } else {
          this.setState({
            editSaving: true,
            isSubTestError: false
          }, () => {
            this.props.saveEditTest({ ...test, signaltekeditdetails }, pager)
          })
        }
      }
    }
  }

  handleErrors = (errors) => {
    this.setState({ errors });
  }

  addSubTestDetails = (type, details) => {
    let { test, testCount } = this.state;
    test[type] = true;
    test[type + "details"] = details;

    if (testCount <= 0) {
      ++testCount;
    }
    this.setState({
      test,
      testCount
    });
  };

  editTestDetails = (e) => {
    if (["findreplacetestnames", "addchangeengineer"].includes(e.target.name)) {
      this.setState({ [e.target.name]: !this.state[e.target.name] })
    } else {
      this.setState({ [e.target.name]: e.target.value })
    }
  }

  render() {

    const {
      classes,
      translate,
      job,
      multiple,
      testNames,
      lengthMeasurementUnit,
      mixedIdentifiers
    } = this.props

    let {
      custom,
      standards,
      error,
      type,
      hasResult
    } = this.props

    let metadataOption
    const {
      test,
      errors,
      tabs,
      tabPosition,
      disabledToogleIdentifier,
      testHasResultWithMetaData,
      allowMetadataEdit,
      isSubTestError,
      tabView,
      findreplacetestnames,
      replaceName,
      findName,
      addchangeengineer,
      engineerName,
      modalRef,
      qualification,
      fiberQualification
    } = this.state

    if (!custom) return null;

    custom = custom.sort((a, b) => b.level > a.level);
    let showAllMetadataSwitch = this.state.test.metadata ? (this.state.test.metadata.filter(n => n.value).length !== 6) : null

    return (
      <Modal
        open={this.state.open}
        onClose={this.handleClose}
      >
        <div className={classes.root}>
          <DraggableModalFrame
            paperClassName={classes.modal}
            header={
              <ModalHeader>
              <Typography type="headline" color="inherit">
                {translate("test_edit_title")}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
                <Icon>clear</Icon>
              </Button>
              </ModalHeader>
            }
          >
            <ModalContents>
              {(error && error === 'error_duplicatetest' && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("test_duplicate_error")}
                </Typography>
                <Typography component="p" color="secondary">
                  {translate("test_duplicate_error_desc")}
                </Typography>
              </Paper>
              ))}
              {(error && error === 'error_testnamesize_exceeds_80chars' && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("import_test_ids_invalid_length")}
                </Typography>
              </Paper>
              ))}
              {(error && error === 'nvp_out_of_range' && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("test_nvp_out_of_range")}
                </Typography>
                <Typography component="p" color="secondary">
                  {translate("test_nvp_out_of_range_desc", { min: 50, max: 99 })}
                </Typography>
              </Paper>
              ))}
              {(error && error === "tests_name_couldn't_be_replaced" && (<Paper className={classes.error} elevation={0}>
                <Typography variant="headline" component="h3" color="secondary">
                  {translate("testlist_couldnot_be_updated", { tests: testNames.join(", ") })}
                </Typography>
                <Typography component="p" color="secondary">
                  {translate("test_name_couldnot_be_blanck")}
                </Typography>
              </Paper>
              ))}
              <form noValidate autoComplete="off" className={classes.form} ref={modalRef}>
                <Tabs value={tabPosition} onChange={this.handleTabChange}>
                  {tabs.map((tab, index) => {
                    return <Tab key={index} label={translate(tab)} />;
                  })}
                </Tabs>

                {(tabView === "tab_details" && !multiple) && (
                  <div className={classes.summary}>
                    <div>
                      <TextField
                        error={errors.name ? true : false}
                        required
                        name="name"
                        label={translate("test_name")}
                        margin="normal"
                        fullWidth
                        value={test.name ? test.name : ''}
                        onChange={this.onChange}
                        inputProps={{
                          maxlength: 76
                        }}
                        helperText={errors.name ? errors.name : translate("test_name_help")}
                      />
                    </div>
                  </div>
                )}
                {tabView === "tab_identifiers" && (
                  <div className={classes.summary}>
                    {mixedIdentifiers && (
                      <Paper className={classes.warning} elevation={0}>
                        <Typography component="p">
                          {translate("test_mixed_identifiers_cannot_edit")}
                        </Typography>
                      </Paper>
                    )}
                    {showAllMetadataSwitch && (
                      <Typography type="subheading">
                        <FormControlLabel
                          control={
                            <Switch
                              name="allmetadataoptions"
                              checked={test.allmetadataoptions}
                              onChange={(e, checked) =>
                                this.onToggleChange(e, checked)
                              }
                              disabled={mixedIdentifiers}
                            />
                          }
                          label={translate("test_add_metadata_item")}
                        />
                      </Typography>
                    )}

                    {custom &&
                      custom
                        .sort((a, b) => {
                          return a.level > b.level
                            ? -1
                            : a.level < b.level
                              ? 1
                              : 0;
                        })
                        .map((c, index) => {
                          metadataOption = test.metadata.find(
                            x =>
                              parseInt(x.level, 10) === parseInt(c.level, 10)
                          );
                          return (test.allmetadataoptions ||
                            metadataOption.default ||
                            metadataOption.enabled) &&
                            c.level !== 1 ? (
                              <div key={index}>
                                <Checkbox
                                  name={c.level}
                                  checked={metadataOption.enabled}
                                  onChange={this.onCustomCheckChange}
                                  disabled={mixedIdentifiers}
                                />
                                <select
                                  name={c.level}
                                  value={metadataOption.field}
                                  onChange={this.onCustomChange}
                                  disabled={!metadataOption.enabled || mixedIdentifiers}
                                >
                                  {c.values.map((o, index) => {
                                    return (
                                      <option key={index} value={o.id}>
                                        {o.name}
                                      </option>
                                    );
                                  })}
                                </select>
                                <TextField
                                  error={errors[c.level] ? true : false}
                                  required
                                  name={c.level}
                                  margin="normal"
                                  value={metadataOption.value}
                                  onChange={this.onChangeMetadataField}
                                  disabled={!metadataOption.enabled || mixedIdentifiers}
                                />
                              </div>
                            ) : null;
                        })}
                  </div>
                )}
                {tabView === "test_edit_details" && (
                  <div className={classes.summary}>
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox name="findreplacetestnames" checked={findreplacetestnames} onChange={this.editTestDetails} />
                        }
                        label={<b>{translate("find_and_replace_test_name")}</b>}
                      />
                    </Typography>
                    {findreplacetestnames ? <Grid container>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          error={errors.findName ? true : false}
                          name="findName"
                          label={translate("test_name_find")}
                          margin="normal"
                          fullWidth
                          value={findName}
                          onChange={this.editTestDetails}
                          helperText={errors.findName ? errors.findName : translate("test_name_find_helper")}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          error={errors.replaceName ? true : false}
                          label={translate("test_name_replace")}
                          name="replaceName"
                          margin="normal"
                          fullWidth
                          value={replaceName}
                          onChange={this.editTestDetails}
                          inputProps={{
                            maxlength: 80
                          }}
                          helperText={errors.replaceName ? errors.replaceName : translate("test_name_replace_helper")}
                        />
                      </Grid>
                    </Grid> : null}
                    <Typography type="subheading">
                      <FormControlLabel
                        control={
                          <Checkbox name="addchangeengineer" checked={addchangeengineer} onChange={this.editTestDetails} disabled={!hasResult} />
                        }
                        label={!hasResult ? (<Typography style={{ color: '#dddddd' }}> <b>{translate("add_or_change_engineer")}</b></Typography>) : (<b>{translate("add_or_change_engineer")}</b>)}
                      />
                    </Typography>
                    {addchangeengineer ? <Grid container>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          error={errors.engineerName ? true : false}
                          name="engineerName"
                          label={translate("test_engineer_name")}
                          margin="normal"
                          fullWidth
                          value={engineerName}
                          onChange={this.editTestDetails}
                          helperText={errors.engineerName ? errors.engineerName : translate("test_engineer_name_helper")}
                        />
                      </Grid>
                    </Grid> : null}
                  </div>
                )}
                {tabView === "tab_qualification" && (
                  <div className={classes.summary}>
                    <Qualification
                    selectedTest={"qualification"}
                    qualification={this.state.qualification}
                    translate={translate}
                    updateQualification={this.addSubTestDetails}
                    handleErrors={this.handleErrors}
                    isTestEdit={true}
                    showTestCreationCancelConfirmation={false}
                    onTestCreationCancelConfirm={this.onTestCreationCancelConfirm}
                    hideTestCreationCancelConfirm={this.hideTestCreationCancelConfirm}
                    customerId={job.customerId}
                  />
                  </div>
              )}
                {tabView === "tab_fiber_qualification" && (
                  <div className={classes.summary}>
                    <FiberQualification
                      selectedTest={"fiberlengthloss"}
                      fiberQualification={this.state.fiberQualification}
                      translate={translate}
                      updateFiberQualification={this.addSubTestDetails}
                      handleErrors={this.handleErrors}
                      isTestEdit={true}
                      showTestCreationCancelConfirmation={false}
                      onTestCreationCancelConfirm={this.onTestCreationCancelConfirm}
                      hideTestCreationCancelConfirm={this.hideTestCreationCancelConfirm}
                      customerId={job.customerId}
                      lengthMeasurementUnit={lengthMeasurementUnit}
                    />
                  </div>
              )}
              </form>
            </ModalContents>

            <ModalFooter>
              {isSubTestError == true ? (
                <Typography className={classes.sterror}>
                  {translate("add_cust_subtest_required")}
                </Typography>
              ) : null}
              <Button raised
                className={classes.button}
                onClick={() => this.tabBack()}
                disabled={(!this.canTabBack().can) ? true : false}
              >
                <Icon>navigate_before</Icon>
              </Button>

              <Button raised
                className={classes.button}
                onClick={() => this.tabNext()}
                disabled={(!this.canTabNext().can) ? true : false}
              >
                <Icon>navigate_next</Icon>
              </Button>

              {
                (this.tabsComplete()) ? (
                  <Button raised
                    color="accent"
                    className={classes.submit}
                    onClick={() => this.editTest()}
                    type="submit"
                  >
                    {translate('test_edit')}
                  </Button>
                ) : (null)
              }

            </ModalFooter>
          </DraggableModalFrame>
        </div>
      </Modal>
    )
  }

  componentWillReceiveProps(nextProps) {
    const { translate, job, standards, multiple, selectedTests } = this.props
    const { props } = this
    let { test } = this.props
    if (test && test.engineer && !this.state.engineerName) {
      this.setState({ engineerName: test.engineer })
    }
    const { isCopper, isFiber, hasResult, onlyCopper, allCoperHasResult, onlyFiber, allFiberHasResult, partialResult, mixedIdentifiers } = nextProps
    const { editSaving } = this.state
    let tabs = []
    let tabView = "tab_details"
    let { cablemodels, linkmodels, cabletypes, isNonGenericCableBrand, testHasResultWithMetaData, allowMetadataEdit, isTestInit } = this.state
    if (test && !editSaving && !isTestInit) {
      if (test.metadata) {
        let metadata = [...test.metadata]
        let curStateMetaData = [...this.state.test.metadata]
        metadata.forEach(e => {
          curStateMetaData.forEach(ce => {
            if (ce.level === e.level) {
              ce.field = e.field
              ce.value = e.value
              e.value ? (ce.enabled = true) : (ce.enabled = false)
            }
          });
        });
        test.metadata = curStateMetaData
        test.allmetadataoptions = true
      }
      let identifierTestCount = 0;
      selectedTests.forEach((test) => {
        const {
          level2key, level2value,
          level3key, level3value,
          level4key, level4value,
          level5key, level5value,
          level6key, level6value,
        } = test;
        if (test)
          if (level2key || level2value ||
            level3key || level3value ||
            level4key || level4value ||
            level5key || level5value ||
            level6key || level6value) {
            identifierTestCount++;
          }
      })
      allowMetadataEdit = ([selectedTests.length].includes(identifierTestCount)) ? true : false
      if (mixedIdentifiers) {
        allowMetadataEdit = false
      }
      if (!multiple) {
        if (isCopper || isFiber) {
          if (hasResult) {
            tabs = [
              "tab_details",
              "tab_identifiers",
              "test_edit_details"
            ]
          } else {
            if (isFiber) {
              tabs = [
                "tab_details",
                "tab_identifiers",
                "test_edit_details",
                "tab_fiber_qualification"
              ]
            } else {
              tabs = [
                "tab_details",
                "tab_identifiers",
                "test_edit_details",
                "tab_qualification"
              ]
            }
          }
          tabView = "tab_details"
        }
      } else if (multiple) {
        if (onlyCopper) {
          if (allCoperHasResult || partialResult) {
            tabs = ["tab_identifiers", "test_edit_details"]
          } else {
            tabs = [
              "tab_identifiers",
              "test_edit_details",
              "tab_qualification"
            ]
          }
        } else if (onlyFiber) {
          if (allFiberHasResult || partialResult) {
            tabs = ["tab_identifiers", "test_edit_details"]
          } else {
            tabs = [
              "tab_identifiers",
              "test_edit_details",
              "tab_fiber_qualification"
            ]
          }
        } else {
          tabs = ["tab_identifiers", "test_edit_details"]
        }
        tabView = "tab_identifiers"
      }

      this.setState({
        tabs,
        test: {
          ...test
        },
        hasResult,
        testHasResultWithMetaData,
        allowMetadataEdit,
        isTestInit: true,
        tabView
      })
    }

    const {
      qualification,
      fiberQualification
    } = nextProps;

    if (test && test.qualificationdetails) {
      this.setState({ qualification: test.qualificationdetails });
    }
    else if (qualification && this.props.qualification != qualification) {
      this.setState({ qualification });
    }
    if (test && test.fiberlengthlossdetails) {
      this.setState({ fiberQualification: test.fiberlengthlossdetails });
    }
    else if (fiberQualification && this.props.fiberQualification != fiberQualification) {
      this.setState({ fiberQualification });
    }
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(QualificationEditTests)
);
